// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpressCheckoutButton_container__e_aKT","button":"ExpressCheckoutButton_button__O4K4i"};